import request from '../config/axiosConfig';
import {
  GET_LIST_BANNERS,
  GET_BANNER_DETAIL,
  CREATE_UPDATE_BANNER,
  DELETE_BANNER,
  BANNER_STATUS_CHANGE,
} from '../constants/apiEndPoint';

export const getListBannersRequest = async (params) => {
  const result = await request({
    url: GET_LIST_BANNERS,
    method: 'POST',
    data: params,
  });
  return result?.data?.data;
};

export const getBannerDetailRequest = async (id) => {
  const result = await request({
    url: GET_BANNER_DETAIL,
    method: 'POST',
    data: { id },
  });
  return result?.data?.data?.data;
};

export const createUpdateBannerRequest = async (data) => {
  const result = await request({
    url: CREATE_UPDATE_BANNER,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const createBannerRequest = async (data) => {
  const result = await request({
    url: CREATE_UPDATE_BANNER,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const deleteBannerRequest = async (id) => {
  const result = await request({
    url: DELETE_BANNER,
    method: 'POST',
    data: { id },
  });
  return result?.data;
};

export const bannerStatusChangeRequest = async (data) => {
  const result = await request({
    url: BANNER_STATUS_CHANGE,
    method: 'POST',
    data,
  });
  return result?.data;
};
